export const antdTheme = {
  token: {
    colorPrimary: "#0a467f",
  },
};
